import React, { Component } from 'react';
import {Link} from 'react-router-dom';
class InforComponent extends Component {
    render() {
        return (
            <div className="container">
                <div className="content-page-wrap">
                    <div className="flat-about-info">
                        <div className="info-img border-ra4">
                            <Link to="#"><img src="images/about/into.jpg" alt="bookflare" /></Link>
                        </div>
                        <div className="info-content border-ra4 border-f-e6f3ff">
                            <div className="heading">
                                <h6 className="title-small"> NEED TO KNOW </h6>
                                <h3 className="title"><Link to="#">Driving Innovation</Link></h3>
                            </div>
                            <p className="text">Hello, World! We are tophive. A space for learning design, technology and
                                entrepreneurship at the highest level, situated in globally admired creative hub and harbour city:
                                Barcelona</p>
                            <p className="text">In 1792 the Counter Hill Academy opened its doors in New Cross, in a house built by
                                Deptford distiller, William Goodhew. The Royal Naval School then bought the site, building what is
                                now our Richard Hoggart Building in 1843.</p>
                            <p className="text font-Publico">A transformational experience that will shape your unique profile and
                                help you launch your professional career.</p>
                            <p className="text">With the dawn of the twentieth century, the Company handed over the Institute to the
                                University of London. It was re-christened Goldsmiths College and the modern era of Goldsmiths had
                                begun.</p>
                            <div className="wrap-btn">
                                <Link to="#" className="flat-button btn-contact ">CONTACT US</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default InforComponent;